/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pkg': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<g _fill="#C4FFF9" fill-rule="nonzero"><path pid="0" d="M37.984 79.898v23.876l35.868 13.305v-44.32L63.243 86.79z"/><path pid="1" d="M62.36 84.196l10.711-14.18-3.812-1.054-31.274-8.711-.719-.196-1.555 1.922-9.859 12.258 9.859 2.695 2.274.618zM76.148 72.758v44.32l35.868-13.305V79.897l-25.258 6.891z"/><path pid="2" d="M112.734 60.054l-.719.195-17.664 4.922-17.422 4.844 10.711 14.18 24.376-6.649 2.274-.617 9.859-2.695-9.859-12.258zM109.054 45.078L75 34.859 40.938 45.078 75 54.562zM73.868 56.61l-32.93-9.172v11.274l32.93 9.171zM76.132 56.61v11.273l.492-.14 32.43-9.031V47.438z"/><path pid="3" d="M111.328 43.39v13.633l1.336.398 9.812-14.937-34.648-9.563-2.257 2.735zM64.43 35.656l-2.258-2.734-34.648 9.562 9.813 14.938 1.328-.399V43.39z"/></g>'
  }
})
